module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAcAQMAAACnASbpAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAABRJREFUCNdj+P///w8GNIJYQGW9AP2mL30T2vHnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/com/white_nav_icon1.png
// module id = WZ4i
// module chunks = 30